export const DeliveryIconSameDaysV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
      <path d="M6.5 3H3.5" stroke="#FA4147" stroke-linecap="round" />
      <path d="M6.5 4.5H2.5" stroke="#E82026" stroke-linecap="round" />
      <path d="M6.5 6H0.5" stroke="#FA4147" stroke-linecap="round" />
      <path d="M6.5 7.5H2.5" stroke="#E82026" stroke-linecap="round" />
      <path d="M8.5604 10.4863H7.96021V13.6036H8.5604V10.4863Z" fill="#C60E13" />
      <path
        d="M8.523 13.5998C9.30197 13.5998 9.93345 12.9028 9.93345 12.0431C9.93345 11.1833 9.30197 10.4863 8.523 10.4863C7.74403 10.4863 7.11255 11.1833 7.11255 12.0431C7.11255 12.9028 7.74403 13.5998 8.523 13.5998Z"
        fill="#A3040B"
      />
      <path
        d="M8.01324 13.5998C8.79221 13.5998 9.42369 12.9028 9.42369 12.0431C9.42369 11.1833 8.79221 10.4863 8.01324 10.4863C7.23426 10.4863 6.60278 11.1833 6.60278 12.0431C6.60278 12.9028 7.23426 13.5998 8.01324 13.5998Z"
        fill="#C60E13"
      />
      <path
        d="M7.96071 12.532C8.20517 12.532 8.40335 12.3136 8.40335 12.0443C8.40335 11.775 8.20517 11.5566 7.96071 11.5566C7.71624 11.5566 7.51807 11.775 7.51807 12.0443C7.51807 12.3136 7.71624 12.532 7.96071 12.532Z"
        fill="white"
      />
      <path d="M14.9029 10.4863H14.3027V13.6036H14.9029V10.4863Z" fill="#C60E13" />
      <path
        d="M14.8648 13.5998C15.6438 13.5998 16.2753 12.9028 16.2753 12.0431C16.2753 11.1833 15.6438 10.4863 14.8648 10.4863C14.0858 10.4863 13.4543 11.1833 13.4543 12.0431C13.4543 12.9028 14.0858 13.5998 14.8648 13.5998Z"
        fill="#A3040B"
      />
      <path
        d="M14.355 13.5998C15.134 13.5998 15.7655 12.9028 15.7655 12.0431C15.7655 11.1833 15.134 10.4863 14.355 10.4863C13.5761 10.4863 12.9446 11.1833 12.9446 12.0431C12.9446 12.9028 13.5761 13.5998 14.355 13.5998Z"
        fill="#C60E13"
      />
      <path
        d="M14.3031 12.532C14.5476 12.532 14.7458 12.3136 14.7458 12.0443C14.7458 11.775 14.5476 11.5566 14.3031 11.5566C14.0587 11.5566 13.8605 11.775 13.8605 12.0443C13.8605 12.3136 14.0587 12.532 14.3031 12.532Z"
        fill="white"
      />
      <path
        d="M5.15515 5L2.15511 10.5C1.65515 11.5 2.48114 12.0484 2.96504 12.0484H10.5946C11.0785 12.0484 11.4687 11.6583 11.4687 11.1744V6.48537C11.4687 6.00147 11.8588 5.61134 12.3427 5.61134H13.0179C13.5018 5.61134 13.8919 5.22122 13.8919 4.73731C13.8919 4.25341 13.5018 3.86328 13.0179 3.86328L5.96504 3.86328C5.48114 3.86328 5.65483 3.86328 5.15515 5Z"
        fill="#C60E13"
      />
      <path
        d="M5.23147 3.37403C4.08488 5.84493 3.30162 8.02911 2.15503 10.5C2.15503 10.9839 2.48119 11.2595 2.96509 11.2595H10.658C11.1419 11.2595 11.532 10.8694 11.532 10.3855V6.48457C11.532 6.00067 11.9221 5.61054 12.406 5.61054H13.0813C13.5652 5.61054 13.9555 4.75432 13.9553 3.37403C13.9553 2.89013 13.5652 2.5 13.0813 2.5H6.10549C5.62159 2.5 5.68919 2.5 5.23147 3.37403Z"
        fill="#FA4147"
      />
      <path
        d="M8.01069 4.14871C8.04729 4.16909 8.07602 4.20114 8.09229 4.23974C8.10855 4.27835 8.11142 4.32129 8.10044 4.36172L7.60243 6.18748H9.41944C9.45598 6.18748 9.49173 6.19816 9.52228 6.2182C9.55283 6.23824 9.57686 6.26678 9.59142 6.30029C9.60597 6.33381 9.61042 6.37085 9.6042 6.40686C9.59799 6.44287 9.58139 6.47628 9.55644 6.50298L6.93143 9.31549C6.90284 9.34619 6.86478 9.36642 6.82334 9.37293C6.78189 9.37944 6.73947 9.37187 6.70283 9.35143C6.6662 9.33098 6.63749 9.29884 6.62128 9.26015C6.60507 9.22145 6.60231 9.17844 6.61343 9.13799L7.11143 7.31248H5.29442C5.25788 7.31248 5.22214 7.3018 5.19159 7.28176C5.16103 7.26171 5.137 7.23318 5.12245 7.19966C5.10789 7.16615 5.10345 7.12911 5.10966 7.0931C5.11588 7.05709 5.13248 7.02368 5.15742 6.99698L7.78244 4.18446C7.81103 4.15388 7.84903 4.13374 7.8904 4.12726C7.93177 4.12078 7.97411 4.12833 8.01069 4.14871Z"
        fill="white"
      />
      <path d="M11.3007 5.50586H16.4579L18.0913 7.04136V11.4045L16.9502 12.081H11.3007" fill="#FA4147" />
      <path d="M13.7662 5.50586L15.41 6.87567V12.081H11.1084V5.55319L13.7662 5.50586Z" fill="#FA4147" />
      <path d="M5.06504 10.4863H4.46484V13.6036H5.06504V10.4863Z" fill="#C60E13" />
      <path
        d="M5.02666 13.5998C5.80563 13.5998 6.43712 12.9028 6.43712 12.0431C6.43712 11.1833 5.80563 10.4863 5.02666 10.4863C4.24769 10.4863 3.61621 11.1833 3.61621 12.0431C3.61621 12.9028 4.24769 13.5998 5.02666 13.5998Z"
        fill="#A3040B"
      />
      <path
        d="M4.5169 13.5998C5.29587 13.5998 5.92735 12.9028 5.92735 12.0431C5.92735 11.1833 5.29587 10.4863 4.5169 10.4863C3.73793 10.4863 3.10645 11.1833 3.10645 12.0431C3.10645 12.9028 3.73793 13.5998 4.5169 13.5998Z"
        fill="#C60E13"
      />
      <path
        d="M4.46492 12.6467C4.76753 12.6467 5.01284 12.3765 5.01284 12.0431C5.01284 11.7097 4.76753 11.4395 4.46492 11.4395C4.16231 11.4395 3.91699 11.7097 3.91699 12.0431C3.91699 12.3765 4.16231 12.6467 4.46492 12.6467Z"
        fill="white"
      />
      <path
        d="M17.7973 6.87695H15.3459V12.0822H16.8858C17.5084 12.0822 18.013 11.5779 18.013 10.9554V7.69884C18.013 7.47967 18.0713 7.15092 17.7973 6.87695Z"
        fill="#C60E13"
      />
      <path
        d="M11.5109 2.5C10.9057 2.5 10.415 2.99063 10.415 3.59585V11.26L11.2369 10.986V6.60261C11.2369 5.99739 11.7276 5.50676 12.3328 5.50676H13.575C13.7954 5.50676 13.9766 5.33341 13.9766 5.12238V2.88438C13.9766 2.67335 13.7954 2.5 13.575 2.5H11.5109Z"
        fill="#C60E13"
      />
      <path d="M12.0992 10.5469H11.499V13.6641H12.0992V10.5469Z" fill="#C60E13" />
      <path
        d="M12.058 13.6604C12.837 13.6604 13.4685 12.9634 13.4685 12.1036C13.4685 11.2439 12.837 10.5469 12.058 10.5469C11.2791 10.5469 10.6476 11.2439 10.6476 12.1036C10.6476 12.9634 11.2791 13.6604 12.058 13.6604Z"
        fill="#A3040B"
      />
      <path
        d="M11.5512 13.6604C12.3302 13.6604 12.9617 12.9634 12.9617 12.1036C12.9617 11.2439 12.3302 10.5469 11.5512 10.5469C10.7722 10.5469 10.1407 11.2439 10.1407 12.1036C10.1407 12.9634 10.7722 13.6604 11.5512 13.6604Z"
        fill="#C60E13"
      />
      <path
        d="M11.4982 12.7092C11.8009 12.7092 12.0462 12.439 12.0462 12.1056C12.0462 11.7722 11.8009 11.502 11.4982 11.502C11.1956 11.502 10.9503 11.7722 10.9503 12.1056C10.9503 12.439 11.1956 12.7092 11.4982 12.7092Z"
        fill="white"
      />
      <path
        d="M14.4231 7.59375C14.0231 7.59375 13.7579 8.00836 13.9256 8.37144L14.48 9.57164C14.5696 9.7656 14.7638 9.88979 14.9775 9.88979H18.0134L18.0294 7.59375H14.4231Z"
        fill="white"
      />
      <path d="M15.3459 9.89033V7.59375H18.0307V9.89033H15.3459Z" fill="#F4F4F4" />
    </svg>
  );
};
